
import Konva from "konva";
export default {
  //預作單一物件轉換，可參考CC 1800行起,接收新增刪除修改物件
  findhtexItex(uuid) {
    let layer = this.layer
    layer.children.forEach(item => {
      if (item.htexUUID == uuid) {
        return item //之後回傳Item
      }
    })
  },
  //取得UUID
  genUUID() {
    let d = Date.now()
    //Performance.now() 亞毫秒級的時間戳記
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now()
    }
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      //xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
      let r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
  },

  async htexToKonvaByFetchJson(konvaComponent) {
    let currentHtexPageDataURL = konvaComponent.currentHtexPageDataURL
    let layer = konvaComponent.layer
    let htexFilePath = konvaComponent.currentHtexFilePath
    let blobSas_read = konvaComponent.blobSasRead

    console.log(currentHtexPageDataURL, 'currentHtexPageDataURL')
    await fetch(currentHtexPageDataURL)
      .then(res => {
        return res.json()
      })
      .then(async htexData => {
        let _this = this
        //置入純色背景
        if (htexData.fill?.solidFill) {
          let bgColor = '#' + htexData.fill?.solidFill.toLowerCase().slice(3, 9) + htexData.fill?.solidFill.toLowerCase().slice(1, 3)
          let background = new Konva.Rect({
            x: 0,
            y: 0,
            fill: bgColor,
            index: 0,
            width: konvaComponent.isCoworkStageScaleHT?konvaComponent.teacherLargeW:window.innerWidth, //改成老師的最大寬
            height: konvaComponent.isCoworkStageScaleHT?konvaComponent.teacherLargeH:window.innerHeight,//改成老師的最大高
            illLinearGradientStartPoint: { x: 0, y: 0 },
            listening: false,
            name: 'bgRect'
          })
          layer.add(background)
          background.moveToBottom()
          layer.draw()
          konvaComponent.$q.loading.hide()
        }
        //置入連結背景
        if (htexData.fill?.blipFill?.url) {
          let pdfSrc = konvaComponent.blobUrl+'/records/'+konvaComponent.activityRecordNumber + htexFilePath  + htexData.fill.blipFill.url + '?' + blobSas_read
          console.log(pdfSrc,'pdfSrc')

          Konva.Image.fromURL(pdfSrc, function(image) {
            let bgRatio = _this.calScaleRatio(image.width(), image.height(), layer.width(), layer.height()).ratio
            let bgScreenOffsetX = _this.calScaleRatio(image.width(), image.height(), layer.width(), layer.height()).screenOffsetX
            let bgScreenOffsetY = _this.calScaleRatio(image.width(), image.height(), layer.width(), layer.height()).screenOffsetY
            console.log(layer.width(), layer.height(),bgRatio)
            image.setAttrs({
              x: -bgScreenOffsetX,
              y: -bgScreenOffsetY,
              width: image.width() * bgRatio,
              height: image.height() * bgRatio,
              index: 0,
              src: pdfSrc,
              name: 'boardPdfBg'
            })

            layer.add(image)
            image.moveToBottom()
            layer.draw()
            konvaComponent.$q.loading.hide()
          })
        }

        if (htexData?.item) {
          const promises = [];

          let htexItemFinallength= 0
          let imgItemLength=0
          htexData?.item.forEach((pathItem) => {
             if(pathItem.type === 'Brush'||pathItem.type === "HtexMask"||pathItem.type === 'Sp'||pathItem.mediaType == 'file' || pathItem.mediaType == 'video' || pathItem.mediaType == 'audio'||pathItem.mediaType == 'image'){
              htexItemFinallength++
             }
             if(pathItem.mediaType == 'image'){
              imgItemLength++
             }
          })
         
          promises.push( htexData.item.map(async (pathItem, k) => {
            await this.htexToKonva(k, pathItem, htexData, layer, htexFilePath, blobSas_read, konvaComponent);
          }))
          await Promise.all(promises).then(() => {
            const intervalId = setInterval(checkLength, 200);

            let ratio = _this.calScaleRatio(htexData.width, htexData.height, layer.width(), layer.height(),konvaComponent).ratio
            let screenOffsetX = _this.calScaleRatio(htexData.width, htexData.height, layer.width(), layer.height(),konvaComponent).screenOffsetX
            let screenOffsetY = _this.calScaleRatio(htexData.width, htexData.height, layer.width(), layer.height(),konvaComponent).screenOffsetY

           
            function checkLength() {
              // console.log(layer?.children.length > htexItemFinallength, layer?.children.length, htexItemFinallength)
              let layerImgLength=0
              layer?.children.forEach((item) => {
                if (item.className == "Image") {
                  layerImgLength++
                }
              })
              //  console.log(layer?.children.length ,layerImgLength, imgItemLength )
              if (layer?.children.length >htexItemFinallength&& layerImgLength>=imgItemLength) {
                // console.log("Lengths are equal or greater.");

                clearInterval(intervalId); // 停止檢查
                //群組物件
                //比對itemGroup 將已經加入uid 在layer挑出來 add到空group中, 刪除原本的
                if (htexData?.itemGroup) {
                  for (const [key] of Object.entries(htexData.itemGroup)) {
                    let htexDataItemIndex = htexData?.item.findIndex((item) => item.uid === key);

                    let pathItem = htexData.item[htexDataItemIndex];

                    let groupWrap = new Konva.Group({
                      x: Number(pathItem.style.position?.x*ratio-screenOffsetX + pathItem.style.position.cx*ratio/2),
                      y: Number(pathItem.style.position?.y*ratio-screenOffsetY + pathItem.style.position.cy*ratio/2),
                      offsetX:Number(pathItem.style.position?.cx*ratio/2),
                      offsetY:Number(pathItem.style.position?.cy*ratio/2),
                      uuid: pathItem?.uid,
                      rotation: pathItem.style.position?.rot,
                      draggable: pathItem?.lock == true ? false : true,
                      listening: true,
                      lock: pathItem?.lock == true,
                      index: pathItem.index,
                      copy: pathItem?.copy ? pathItem?.copy : false,
                      name: "HtexGroup",
                    });

                    htexData.itemGroup[key].forEach((uid) => {
                      let konvaObjIndex = layer.children.findIndex((konvaItem) => konvaItem.attrs.uuid == uid);
                      // console.log(konvaObjIndex, "htexData?.item");

                      if (konvaObjIndex != -1) {
                        groupWrap.add(
                          new Konva[layer.children[konvaObjIndex].className]({
                            parent: groupWrap,
                            ...layer.children[konvaObjIndex].attrs,
                            x:Number((layer.children[konvaObjIndex].attrs?.x-(pathItem.style.position?.x*ratio-screenOffsetX)).toFixed(0)),
                            y:Number((layer.children[konvaObjIndex].attrs?.y-(pathItem.style.position?.y*ratio-screenOffsetY)).toFixed(0))
                          })
                        );
                        layer.children.splice(konvaObjIndex, 1);
                      }
                    });
                    layer.add(groupWrap);
                  }
                }
              }
            }
            // console.log("promise all finished");
          });
        }
        
        setTimeout(() => {
          konvaComponent.layer.children.sort(function(a, b) {
            let indexA = a.attrs.index
            let indexB = b.attrs.index
            if (indexA < indexB) {
              return -1
            }
            if (indexA > indexB) {
              return 1
            }
            return 0
          })
          konvaComponent.layer.children.forEach(item => {
            if (item.attrs.name == 'bgRect') {
              item.moveToBottom()
            }
          })
          let items=[]
          for(let i=konvaComponent.layer.children.length;i>0;i--){
            let item=konvaComponent.layer.children[i-1]
            if (item.attrs.name == 'HtexMask') {
              item.attrs.index =konvaComponent.layer.children.length
              konvaComponent.layer.children.splice(i-1, 1)
              items.push(item)
            }
          }
          items.reverse()
          items.forEach(item=>{
            
            konvaComponent.layer.children.push(item)
           
          })  
          
          console.log(layer, 'nowLayer')
          konvaComponent.layer.batchDraw()
          konvaComponent.isRenderHTEX=false
        }, 1000)
      })
  },

  async htexToKonva(k, pathItem, htexData, layer, htexFilePath, blobSas_read, konvaComponent) {
    let ratio = this.calScaleRatio(htexData.width, htexData.height, layer.width(), layer.height()).ratio
    let screenOffsetX = this.calScaleRatio(htexData.width, htexData.height, layer.width(), layer.height()).screenOffsetX
    let screenOffsetY = this.calScaleRatio(htexData.width, htexData.height, layer.width(), layer.height()).screenOffsetY
    let _this = this //目前這包js範圍
   

    //畫筆物件
    if (pathItem.type === 'Brush') {
      let transPointData = []
      pathItem.point_xy.split(' ').forEach(item => {
        let itemArray = item.split(',').map(d => parseInt(d))
        transPointData = transPointData.concat(itemArray)
      })

      let strokeColor = '#' + pathItem.color.toLowerCase().slice(3, 9) + pathItem.color.toLowerCase().slice(1, 3)

      //基本的線條物件
      let lastLine = new Konva.Line({
        uuid: pathItem?.uid,
        x: -screenOffsetX,
        y: -screenOffsetY,
        width: htexData.width * ratio,
        height: htexData.height * ratio,
        points: transPointData,
        stroke: strokeColor,
        index: k,
        strokeWidth: parseInt(pathItem?.point_w) < 1 ? 5 : parseInt(pathItem?.point_w),
        hitStrokeWidth: 30 ,
        lock: pathItem?.lock == true,
        copy:pathItem?.copy?pathItem?.copy:false,
        draggable: pathItem?.lock == true ? false : true,
        scaleX: ratio,
        scaleY: ratio,
        opacity:pathItem?.opacity?pathItem?.opacity:1
      })
      layer.add(lastLine)
    }
     //HT的便利貼或文字物件
     if(pathItem.type === "HtexTextpost"){
      let pathColor = "#" + pathItem.style?.fill?.solidFill.toLowerCase().slice(3, 9) + pathItem.style?.fill?.solidFill.toLowerCase().slice(1, 3);
      let textColor = "#" + pathItem?.textdata.color.toLowerCase().slice(3, 9) + pathItem?.textdata.color.toLowerCase().slice(1, 3);
      let x = _this.ensureNumber(pathItem.style.position?.x) * ratio - screenOffsetX +_this.ensureNumber(pathItem.style.position?.cx) * ratio / 2;
      let y = _this.ensureNumber(pathItem.style.position?.y) * ratio - screenOffsetY + _this.ensureNumber(pathItem.style.position?.cy) * ratio / 2;
      let offsetX = _this.ensureNumber(pathItem.style.position?.cx) * ratio / 2;
      let offsetY = _this.ensureNumber(pathItem.style.position?.cy) * ratio / 2;

      //如果有底色加入文字便利貼，沒有底色變成文字物件
      if(pathItem.style?.fill?.solidFill){
        let pastText = new Konva.Label({
          uuid: pathItem?.uid,
          fontSize: Number((pathItem?.textdata.size * ratio).toFixed(0))<=20?20:Number((pathItem?.textdata.size * ratio).toFixed(0)),
          x: x,
          y: y,
          offsetX:offsetX,
          offsetY:offsetY,
          rotation: pathItem.style.position?.rot,
          index: k,
          name: 'pastText',
          draggable: true,
          listening: true,
          text:pathItem?.textdata.text,
        })
        pastText.add(
          new Konva.Tag({
            uuid: pathItem?.uid,
            fill: pathColor,
            shadowColor: 'black',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.2,
            name: 'pastTextContent',
            draggable: false,
            listening: true,
            index: k,
          })
        )
        pastText.add(
          new Konva.Text({
            uuid: pathItem?.uid,
            text:pathItem?.textdata.text,
            fontSize: pathItem?.textdata.size,
            fill: textColor,
            padding: 20,
            lineHeight: 1,
            width: pathItem.style.position.cx * ratio,
            height:pathItem.style.position.cy * ratio, 
            name: 'pastTextContent',
            draggable: false,
            listening: true,
            index: k,
          })
        )  
        layer.add(pastText)  
      }
      else{
         //新增純文字物件
        let textNode = new Konva.Text({
          uuid: pathItem?.uid,
          text:pathItem?.textdata.text,
          x: pathItem.style.position.x * ratio - screenOffsetX,
          y: pathItem.style.position.y * ratio - screenOffsetY,
          fontSize: pathItem?.textdata.size,
          fill: textColor,
          draggable: true,
          width: 300,
          height: 'auto',
          name: 'text',
          index: k,
        })
        layer.add(textNode)
      }
  }
  
     //遮罩物件
    if (pathItem.type === "HtexMask") {
      // console.log('有遮罩')
      let pathColor = "#" + pathItem.style?.fill?.solidFill.toLowerCase().slice(3, 9) + pathItem.style?.fill.solidFill.toLowerCase().slice(1, 3);
      if (pathItem.style.position.cx != "NaN" && pathItem.style.position.cy != "NaN") {
        let path = new Konva.Rect({
          uuid: pathItem?.uid,
          x: pathItem.style.position.x * ratio - screenOffsetX,
          y: pathItem.style.position.y * ratio - screenOffsetY,
          width: pathItem.style.position.cx,
          height: pathItem.style.position.cy,
          index: k,
          rotation: pathItem.style.position?.rot,
          fill: pathColor,
          links: pathItem?.links ? pathItem?.links : "",
          lock: false,
          copy:pathItem?.copy?pathItem?.copy:false,
          draggable: true,
          htexShapeType: pathItem.shapeType, //幫忙記錄htex原始的物件
          scaleX: ratio,
          scaleY: ratio,
          cornerRadius: pathItem.corner_radius,
          name: "HtexMask",
          opacity:pathItem?.opacity?pathItem?.opacity:1
        });

        layer.add(path);
      }
    }
    //圖形物件
    if (pathItem.type === 'Sp') {
      
      if (pathItem.shapeType === 'custom' || pathItem.shapeType === 'ellipse' || pathItem.shapeType === 'rect') {
        
        //第一種實心圖形
        if (pathItem.style?.fill?.solidFill) {
          let pathColor = '#' + pathItem.style?.fill?.solidFill.toLowerCase().slice(3, 9) + pathItem.style?.fill.solidFill.toLowerCase().slice(1, 3)
          let path = new Konva.Path({
            x: pathItem.style.position.x * ratio - screenOffsetX,
            y: pathItem.style.position.y * ratio - screenOffsetY,
            rotation: pathItem.style.position?.rot,
            uuid: pathItem?.uid,
            index: k,
            data: pathItem.svg.d,
            fill: pathColor,
            links: pathItem?.links ? pathItem?.links : '',
            lock: pathItem?.lock == true,
            copy:pathItem?.copy?pathItem?.copy:false,
            draggable: pathItem?.lock == true ? false : true,
            htexShapeType: pathItem.shapeType, //幫忙記錄htex原始的物件
            scaleX: ratio,
            scaleY: ratio,
            opacity:pathItem?.opacity?pathItem?.opacity:1
          })
          layer.add(path)
        }
        //第二種空心圖形
        if (pathItem.style?.border?.color?.solidFill) {
          let pathColor = '#' + pathItem.style?.border?.color?.solidFill.toLowerCase().slice(3, 9) + pathItem.style?.border?.color?.solidFill.toLowerCase().slice(1, 3)
          let path = new Konva.Path({
            uuid: pathItem?.uid,
            x: pathItem.style.position.x * ratio - screenOffsetX,
            y: pathItem.style.position.y * ratio - screenOffsetY,
            index: k,
            rotation: pathItem.style.position?.rot,
            data: pathItem.svg.d,
            stroke: pathColor,
            links: pathItem?.links ? pathItem?.links : '',
            strokeWidth: pathItem.style?.border?.outline?.width * ratio,
            lock: pathItem?.lock == true,
            copy:pathItem?.copy?pathItem?.copy:false,
            draggable: pathItem?.lock == true ? false : true,
            htexShapeType: pathItem.shapeType, //幫忙記錄htex原始的物件
            scaleX: ratio,
            scaleY: ratio,
            opacity:pathItem?.opacity?pathItem?.opacity:1
          })
          layer.add(path)
        }
      }
    }
    //webpage
    if (pathItem.type === 'webpage') {

      let groupWrap = new Konva.Group({
        uuid: pathItem?.uid,
        x: pathItem.style.position.x * ratio - screenOffsetX,
        y: pathItem.style.position.y * ratio - screenOffsetY,
        width: pathItem.style.position.cx,
        height: pathItem.style.position.cy,
        rotation: pathItem.style.position?.rot,
        copy:pathItem?.copy?pathItem?.copy:false,
        draggable: pathItem?.lock == true ? false : true,
        listening: true,
        lock: pathItem?.lock == true,
        links:[pathItem?.org_url],
        index: k,
        name:"webpageGroup"
      })
      
      if (pathItem.style.position.cx != "NaN" && pathItem.style.position.cy != "NaN") {
        let path = new Konva.Rect({
          uuid: pathItem?.uid,
          x:0,
          y:0,
          width: pathItem.style.position.cx,
          height: pathItem.style.position.cy,
          index: k,
          rotation: pathItem.style.position?.rot,
          fill: '#e1e2e5',
          copy:pathItem?.copy?pathItem?.copy:false,
          draggable: false,
          listening: true,
          scaleX: ratio,
          scaleY: ratio,
          name: "webpage",
          links:[{
            action:"ppaction://hlinkpres",
            url:pathItem?.org_url
          }],
          opacity:pathItem?.opacity?pathItem?.opacity:1
        });

        groupWrap.add(path);

        let text= new Konva.Text({
          x:0,
          y:0,
          text: pathItem?.org_url,
          fontSize: 12,
          fill: 'black',
          padding: 20,
          lineHeight: 1,
          width:  Number(pathItem.style.position.cx* ratio-80),
          height: 'auto', 
          name: "webpage",
          draggable: false,
          listening: true,
          links:[{
            action:"ppaction://hlinkpres",
            url:pathItem?.org_url
          }],
          uuid: pathItem?.uid,
        })
        groupWrap.add(text);
        layer.add(groupWrap)
      }
    }
    //附件物件
    if (pathItem.mediaType == 'file' || pathItem.mediaType == 'video' || pathItem.mediaType == 'audio') {
      let imgUrl = konvaComponent.blobUrl+'/records/'+konvaComponent.activityRecordNumber +htexFilePath  + pathItem.image.url
      let changefileTypeImg = ''

      if (pathItem.file.url.split('.')[pathItem.file.url.split('.').length - 1] == 'doc' || pathItem.file.url.split('.')[pathItem.file.url.split('.').length - 1] == 'docx') changefileTypeImg = konvaComponent.fileTypeImages[0].pathLong
      if (pathItem.file.url.split('.')[pathItem.file.url.split('.').length - 1] == 'pdf') changefileTypeImg = konvaComponent.fileTypeImages[2].pathLong
      if (pathItem.file.url.split('.')[pathItem.file.url.split('.').length - 1] == 'pptx' || pathItem.file.url.split('.')[pathItem.file.url.split('.').length - 1] == 'ppt') changefileTypeImg = konvaComponent.fileTypeImages[3].pathLong
      let paperClipIcon = konvaComponent.fileTypeImages[1].pathLong

      let finalImgUrl = changefileTypeImg != '' ? changefileTypeImg : imgUrl + '?' + blobSas_read
      let fileLinkUrl = konvaComponent.blobUrl+'/records/'+konvaComponent.activityRecordNumber +htexFilePath  + pathItem.file.url + '?' + blobSas_read
      let scaleImgRatio = changefileTypeImg != '' || pathItem.mediaType == 'audio' ? 0.6 : pathItem.mediaType == 'video' ? 0.8 : 1
      let scaleImgPadding = changefileTypeImg != '' && pathItem.mediaType == 'file' ? 20 : pathItem.mediaType == 'audio' ? 25 : 0

      // console.log(konvaComponent.fileTypeImages)

      // console.log('加入圖片')
      let groupWrap = new Konva.Group({
        uuid: pathItem?.uid,
        x: pathItem.style.position.x * ratio - screenOffsetX + (pathItem.style.position.cx * ratio) / 2,
        y: pathItem.style.position.y * ratio - screenOffsetY + (pathItem.style.position.cy * ratio) / 2,
        offsetX: (pathItem.style.position.cx * ratio) / 2,
        offsetY: (pathItem.style.position.cy * ratio) / 2,
        rotation: pathItem.style.position?.rot,
        copy:pathItem?.copy?pathItem?.copy:false,
        draggable: pathItem?.lock == true ? false : true,
        listening: true,
        lock: pathItem?.lock == true,
        index: k,
        name: 'groupFile'
      })
      layer.add(groupWrap)

      Konva.Image.fromURL(finalImgUrl, function(image) {
        image.setAttrs({
          uuid: pathItem?.uid,
          width: (image.width() / 2) * ratio * scaleImgRatio,
          height: (image.height() / 2) * ratio * scaleImgRatio,
          links: pathItem?.links ? pathItem?.links : '',
          filelink: fileLinkUrl,
          filelinkType: pathItem.mediaType,
          copy:pathItem?.copy?pathItem?.copy:false,
          index: k,
          src: changefileTypeImg != '' ? changefileTypeImg : imgUrl,
          draggable: false,
          listenning: false,
          shadowEnabled: changefileTypeImg == '' ? false : true,
          name: 'pastImgContent',
          shadowColor: 'black',
          shadowBlur: 5,
          shadowOffset: { x: 0, y: 1 },
          shadowOpacity: 0.3,
          fromLocal: changefileTypeImg != '' ? true : false
        })

        groupWrap.add(image)
        groupWrap.add(
          new Konva.Text({
            x: -20,
            y: (image.height() / 2) * ratio * scaleImgRatio + 35 + scaleImgPadding,
            text: pathItem.file.url,
            fontStyle: 'bold',
            fontSize: 12,
            fill: 'gray',
            padding: 0,
            lineHeight: 1.2,
            wrap: 'char',
            ellipsis: true,
            width: image.width() + 30,
            height: 20,
            draggable: false,
            listening: false,
            align: 'center',
            name: 'pastImgContent'
          })
        )
        //加上附件符號增加識別
        if (pathItem.mediaType == 'file') {
          Konva.Image.fromURL(paperClipIcon, function(image) {
            image.setAttrs({
              uuid: pathItem?.uid,
              width: 28,
              height: 28,
              x: -8,
              y: -8,
              links: pathItem?.links ? pathItem?.links : '',
              filelink: fileLinkUrl,
              filelinkType: pathItem.mediaType,
              index: k + 2,
              src: paperClipIcon,
              draggable: false,
              listenning: false,
              shadowEnabled: true,
              name: 'pastImgContent',
              shadowColor: 'black',
              shadowBlur: 5,
              shadowOffset: { x: 0, y: 1 },
              shadowOpacity: 0.3,
              fromLocal: changefileTypeImg != '' ? true : false
            })
            groupWrap.add(image)
          })
        }
        layer.batchDraw()
      })
    }

    //圖片物件
    if (pathItem.mediaType == 'image') {
      let fileUrl = konvaComponent.blobUrl+'/records/'+konvaComponent.activityRecordNumber +htexFilePath + pathItem.image.url
      Konva.Image.fromURL(fileUrl + '?' + blobSas_read, function(image) {
        // console.log('加入圖片')
        image.setAttrs({
          uuid: pathItem?.uid,
          x: pathItem.style.position.x * ratio - screenOffsetX + (pathItem.style.position.cx * ratio) / 2,
          y: pathItem.style.position.y * ratio - screenOffsetY + (pathItem.style.position.cy * ratio) / 2,
          width: pathItem.style.position.cx * ratio,
          height: pathItem.style.position.cy * ratio,
          rotation: pathItem.style.position?.rot,
          offsetX: (pathItem.style.position.cx * ratio) / 2,
          offsetY: (pathItem.style.position.cy * ratio) / 2,
          links: pathItem?.links ? pathItem?.links : '',
          index: k,
          draggable: pathItem?.lock == true ? false : true,
          copy:pathItem?.copy?pathItem?.copy:false,
          lock: pathItem?.lock == true,
          src: fileUrl,
          opacity:pathItem?.opacity?pathItem?.opacity:1
        })
        layer.add(image)
        layer.batchDraw()
        // that.$q.loading.hide()
      })
    }

    
    konvaComponent.$q.loading.hide()
  },

}
